import { tns } from 'tiny-slider/src/tiny-slider'; window.tns = tns;

var manufacturerCarousel = tns({
  container: '[data-js-manufacturer-carousel]',
  items: 2,
  slideBy: 'page',
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayHoverPause: true,
  nav: false,
  speed: 800,
  gutter: 15,
  controls: false,
  responsive: {
    650: {
      controls: true,
      items: 3,
    },
    900: {
      items: 4
    },
    1150: {
      items: 5
    }
  }
});